"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteTxBuilder = void 0;
const RegisterAPI_1 = require("../fetchers/RegisterAPI");
const SubAccountAPI_1 = require("../fetchers/SubAccountAPI");
class RemoteTxBuilder {
    constructor(config) {
        this.subAccountAPI = new SubAccountAPI_1.SubAccountAPI(config.subAccountUri);
        this.registerAPI = new RegisterAPI_1.RegisterAPI(config.registerUri);
    }
    enableSubAccount(account, keyInfo) {
        return this.subAccountAPI.initSubAccount(account, keyInfo);
    }
    mintSubAccounts(params) {
        return this.subAccountAPI.createSubAccounts(params);
    }
    changeManager(params) {
        return this.registerAPI.editAccountManager(params);
    }
    changeOwner(params) {
        return this.registerAPI.editAccountOwner(params);
    }
    editRecords(params) {
        return this.registerAPI.editAccountRecords(params);
    }
    editSubAccount(params) {
        return this.subAccountAPI.editSubAccount(params);
    }
}
exports.RemoteTxBuilder = RemoteTxBuilder;
//# sourceMappingURL=RemoteTxBuilder.js.map